// NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
let RivalIQ;
let _;
let moment;
if (typeof window === 'undefined') {

    _ = require('lodash');
    moment = require('../../../lib/riq-moment.js');

    const metrics = require('../metrics.js');

    RivalIQ = {
        enums: require('../../../public/enums/metrics.js'),
        data: {
            CompareData: require('../../../public/modules/data/compareData.js')
        },
        metrics: metrics,
        utils: {}
    };

} else {
    _ = window._;
    moment = window.moment;
    RivalIQ = window.RivalIQ;
    RivalIQ.module('utils', function () {});
}

(function () {

    'use strict';

    const utils = {};

    // Stupid-simple one item date sequence cache.
    let dateSequenceCacheKey = null;
    let dateSequenceCacheValue = null;

    utils.generateDateSequence = function (mainPeriodStart, mainPeriodEnd) {
        const cacheKey = `${mainPeriodStart}|${mainPeriodEnd}`;

        if (dateSequenceCacheKey === cacheKey) {
            return dateSequenceCacheValue;
        }

        const start = moment.utc(mainPeriodStart).startOf('day');
        const end = moment.utc(mainPeriodEnd).endOf('day');

        const days = end.diff(start, 'days') + 1;
        const sequence = new Array(days);
        const current = start.toDate();

        for (let day = 0; day < days; day++) {
            sequence[day] = current.toISOString().substr(0, 10);
            current.setUTCDate(current.getUTCDate() + 1);
        }

        dateSequenceCacheKey = cacheKey;
        dateSequenceCacheValue = sequence;

        return sequence;
    };

    utils.formatChartData = function (mainPeriodStart, mainPeriodEnd, dataValues, dateSequence) {

        dateSequence = dateSequence || utils.generateDateSequence(mainPeriodStart, mainPeriodEnd);
        let day = 0;

        const values = [];
        let maxValue = null;

        for (day = 0; day < dateSequence.length; day++) {
            // Note: this loop is hot-hot-hot. There are 142 standard metrics.
            // When querying for N companies over a D day period, this inner
            // loop executes 142 * N * D times.
            //
            // (When querying Doc's monster "Mayors" landscape (184 "companies")
            // over a 30 day period, this loop executes 142 * 184 * 30 = 783,840
            // times.)
            //
            // Ouch. Avoid moment() here.

            let dataValue = dataValues[day];

            // determine the max value for this company
            if (dataValue > maxValue) {
                maxValue = dataValue;
            }

            // check to see if we even have a value here or not
            if (dataValue === void(0)) {
                dataValue = null;
            }

            values.push({
                date: dateSequence[day],
                total: dataValue
            });
        }

        return {
            maxValue: maxValue,
            values: values
        };
    };

    /**
     * Consumes the daily formattedData produced by formatChartData and creates weekly
     * or monthly roll-ups if the timeAnalysisMode calls for it, otherwise returns the formattedData
     * unchanged.
     *
     * Rollup strategy is to step through each daily value, casting the date to the start of week/month
     * When the daily casted value no longer matches the timePeriodDate, we know we've stepped beyond
     * the week/month bucket and start over with our accumulation.
     *
     * Casting the daily dates to the start of of the week or month naturally means that the dates for
     * the earliest values are usually before the start of the original time period start. Time charts
     * consuming these results should crop the results or expand their time period as they see fit.
     *
     * Depending on the metric type of the data, the roll up is either the last value of the week/month
     * (totals) the average for the period (average_daily_x) or the sum of all values (all other volumes).
     *
     * Engagement metrics can't just be rolled up and are instead recalculated from component pieces,
     * see getEngagementFormattedData...
     *
     * NOTE: partial time periods are "best effort", partial periods at the beginning and end of the time
     * period and segments with missing data will dip in sum case, and will be less accurate in the max
     * case.
     *
     * @param formattedData - output from formatChartData
     * @param timeAnalysisMode
     * @param metric
     * @param compareData
     * @param dates
     * @param companyId
     * @param sourceMask channels to redact. If undefined we will hit landscape
     * state NOTE this means failure if you call from the server and dont
     * define source mask!
     * TODO long term: elminate this file.
     * TODO short term: always call with sourceMask
     * @returns {*}
     */
    utils.rollupFormattedChartData = function (formattedData, timeAnalysisMode, metric, compareData, dates, companyId, sourceMask) {
        const values = [];
        let startOf;
        let timePeriodDate;
        let timePeriodValue = null;
        let timePeriodCount = 0;

        // NOTE this will fail intentionally on the server. You must tell us
        // what sources are active!
        if (_.isUndefined(sourceMask)) {
            sourceMask = RivalIQ.state.landscape.getSourceAccessMask();
        }

        // Note: max is the max across all time period buckets
        // preserve the formattedData.maxValue in the event formatedData.values is empty
        let maxValue = formattedData.maxValue;

        switch (Number(timeAnalysisMode)) {
            case RivalIQ.enums.timeAnalysisMode.WEEKLY_VALUES:
                startOf = 'week';
                break;
            case RivalIQ.enums.timeAnalysisMode.MONTHLY_VALUES:
                startOf = 'month';
                break;
            default:
            // if it's not a rollup, just return the original data
                return formattedData;
        }

        // engagement rollups need to be calculated from component pieces
        const engagementFormattedData = getEngagementFormattedData(compareData, metric, timeAnalysisMode, dates, companyId, sourceMask);
        if (engagementFormattedData) {
            return engagementFormattedData;
        }

        const metricType = compareData.getMetricType(metric);

        _.each(formattedData.values, function (v) {
            const valueDate = moment.utc(v.date).startOf(startOf);

            if (!timePeriodDate) {
                // initialize date and values
                timePeriodDate = valueDate;
                timePeriodValue = v.total;
                timePeriodCount = 1;
                maxValue = v.total;
            } else if (!timePeriodDate.isSame(valueDate)) {
                // we've run off the end of our time period bucket

                // save previous values
                values.push({
                    date: timePeriodDate,
                    total: timePeriodValue,
                    count: timePeriodCount
                });

                // initialize the next bucket
                timePeriodDate = valueDate;
                timePeriodValue = v.total;
                timePeriodCount = 1;

                // max is the max across all time period buckets
                maxValue = Math.max(timePeriodValue, maxValue);
            } else {
                // just another value in the time period bucket
                timePeriodDate = valueDate;

                if (timePeriodValue !== null && v.total !== null) {
                    // most recent value for totals, otherwise sum
                    if (metricType === RivalIQ.enums.metricType.TOTAL) {
                        timePeriodValue = v.total;
                    } else {
                        timePeriodValue += v.total;
                    }
                    timePeriodCount++;

                } else if (v.total !== null) {
                    timePeriodValue = v.total;
                    timePeriodCount = 1;
                }

                // update the max value
                maxValue = Math.max(timePeriodValue, maxValue);
            }
        });

        // save the last interval... (if any)
        if (timePeriodDate) {
            values.push({
                date: timePeriodDate,
                total: timePeriodValue,
                count: timePeriodCount
            });
        }

        // turn daily average sums into average daily averages for each period (and find the new max)
        const results = rollupAverageDailyPostData(metric, {
            maxValue: maxValue,
            values: values
        });

        return results;
    };

    /**
     * pick rollup formula based on metric
     * helper for rollupFormattedChartData
     * @param compareData
     * @param metric
     * @param timeAnalysisMode
     * @param dates
     * @param companyId
     * @param sourceMask channels to redact. Passed down to noChannelAccess()
     * @returns {{maxValue: *, values: *}}
     */
    function getEngagementFormattedData(compareData, metric, timeAnalysisMode, dates, companyId, sourceMask) {
        const metricSource = _.find(RivalIQ.metrics.descriptions, {
            id: Number(metric)
        }).source;

        switch (Number(metric)) {
            case RivalIQ.metrics.id.TWITTER_TWEETS_ENGAGEMENT_RATE:
            case RivalIQ.metrics.id.FACEBOOK_POSTS_ENGAGEMENT_RATE:
            case RivalIQ.metrics.id.YOUTUBE_POSTS_ENGAGEMENT_RATE:
            case RivalIQ.metrics.id.INSTAGRAM_POSTS_ENGAGEMENT_RATE:
                return engagementRateFormattedData(compareData, metricSource, timeAnalysisMode, dates, companyId, sourceMask);

            case RivalIQ.metrics.id.TWITTER_AVERAGE_TWEET_ENGAGEMENT_TOTAL:
            case RivalIQ.metrics.id.FACEBOOK_AVERAGE_POST_ENGAGEMENT_TOTAL:
            case RivalIQ.metrics.id.YOUTUBE_AVERAGE_POST_ENGAGEMENT_TOTAL:
            case RivalIQ.metrics.id.INSTAGRAM_AVERAGE_POST_ENGAGEMENT_TOTAL:
                return engagementTotalFormattedData(compareData, metricSource, timeAnalysisMode, dates, companyId, sourceMask);

            case RivalIQ.metrics.id.TWITTER_AVERAGE_TWEET_ENGAGEMENT_RATE:
            case RivalIQ.metrics.id.FACEBOOK_AVERAGE_POST_ENGAGEMENT_RATE:
            case RivalIQ.metrics.id.YOUTUBE_AVERAGE_POST_ENGAGEMENT_RATE:
            case RivalIQ.metrics.id.INSTAGRAM_AVERAGE_POST_ENGAGEMENT_RATE:
            case RivalIQ.metrics.id.CROSS_CHANNEL_AVG_ENGAGEMENT_RATE_PER_POST:
                return averageEngagementRateFormattedData(compareData, metricSource, timeAnalysisMode, dates, companyId, sourceMask);

            case RivalIQ.metrics.id.TWITTER_AVERAGE_DAILY_TWEETS_ENGAGEMENT_TOTAL:
            case RivalIQ.metrics.id.FACEBOOK_AVERAGE_DAILY_POSTS_ENGAGEMENT_TOTAL:
            case RivalIQ.metrics.id.YOUTUBE_AVERAGE_DAILY_POSTS_ENGAGEMENT_TOTAL:
            case RivalIQ.metrics.id.INSTAGRAM_AVERAGE_DAILY_POSTS_ENGAGEMENT_TOTAL:
                return averageEngagementTotalPerDayFormattedData(compareData, metricSource, timeAnalysisMode, dates, companyId, sourceMask);

            case RivalIQ.metrics.id.TWITTER_AVERAGE_DAILY_TWEETS_ENGAGEMENT_RATE:
            case RivalIQ.metrics.id.FACEBOOK_AVERAGE_DAILY_POSTS_ENGAGEMENT_RATE:
            case RivalIQ.metrics.id.YOUTUBE_AVERAGE_DAILY_POSTS_ENGAGEMENT_RATE:
            case RivalIQ.metrics.id.INSTAGRAM_AVERAGE_DAILY_POSTS_ENGAGEMENT_RATE:
                return averageEngagementRatePerDayFormattedData(compareData, metricSource, timeAnalysisMode, dates, companyId, sourceMask);

            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_PAGE_ENGAGEMENT_RATE:
            case RivalIQ.metrics.id.LINKED_IN_ENGAGEMENT_RATE:
                return averageRateFormattedData(compareData, metric, timeAnalysisMode, dates, companyId, sourceMask);

            default:
                break;
        }
        return null;
    }

    /**
     * gets rollup data for a specific metric and company
     * (used to fetch individual components used to calculate engagement rate rollups)
     * @param compareData
     * @param metric
     * @param timeAnalysisMode
     * @param dates
     * @param companyId
     * @param sourceMask channels to redact. Passed down to noChannelAccess()
     * @returns {{maxValue: *, values: *}}
     */
    function getMetricData(compareData, metric, timeAnalysisMode, dates, companyId, sourceMask) {
        const data = compareData.getTimeSpanData(metric);
        const companyDataValues = _.find(data, {
            companyId: companyId
        }).values;
        const formattedData = utils.formatChartData(dates.mainPeriodStart, dates.mainPeriodEnd, companyDataValues);
        return utils.rollupFormattedChartData(formattedData, timeAnalysisMode, metric, compareData, dates, companyId, sourceMask);
    }

    /**
     * Our average_daily_x metrics are volumes so they will get summed by default.
     * This post rollup helper converts them into period averages and updates the max
     * @param metric
     * @param formattedData
     * @returns {*}
     */
    function rollupAverageDailyPostData(metric, formattedData) {
        switch (Number(metric)) {
            case RivalIQ.metrics.id.TWITTER_AVERAGE_DAILY_TWEETS:
            case RivalIQ.metrics.id.TWITTER_AVERAGE_DAILY_TWEETS_RETWEETS:
            case RivalIQ.metrics.id.TWITTER_AVERAGE_DAILY_TWEETS_FAVORITES:
            case RivalIQ.metrics.id.TWITTER_AVERAGE_DAILY_NORMAL_TWEETS:
            case RivalIQ.metrics.id.TWITTER_AVERAGE_DAILY_RETWEET_TWEETS:
            case RivalIQ.metrics.id.TWITTER_AVERAGE_DAILY_REPLY_TWEETS:
            case RivalIQ.metrics.id.FACEBOOK_AVERAGE_DAILY_POSTS:
            case RivalIQ.metrics.id.FACEBOOK_AVERAGE_DAILY_POSTS_REACTIONS:
            case RivalIQ.metrics.id.FACEBOOK_AVERAGE_DAILY_POSTS_LIKES:
            case RivalIQ.metrics.id.FACEBOOK_AVERAGE_DAILY_POSTS_LOVES:
            case RivalIQ.metrics.id.FACEBOOK_AVERAGE_DAILY_POSTS_HAHAS:
            case RivalIQ.metrics.id.FACEBOOK_AVERAGE_DAILY_POSTS_WOWS:
            case RivalIQ.metrics.id.FACEBOOK_AVERAGE_DAILY_POSTS_SADS:
            case RivalIQ.metrics.id.FACEBOOK_AVERAGE_DAILY_POSTS_ANGRYS:
            case RivalIQ.metrics.id.FACEBOOK_AVERAGE_DAILY_POSTS_COMMENTS:
            case RivalIQ.metrics.id.FACEBOOK_AVERAGE_DAILY_POSTS_SHARES:
            case RivalIQ.metrics.id.YOUTUBE_AVERAGE_DAILY_POSTS:
            case RivalIQ.metrics.id.YOUTUBE_AVERAGE_DAILY_POSTS_VIEWS:
            case RivalIQ.metrics.id.YOUTUBE_AVERAGE_DAILY_POSTS_LIKES:
            case RivalIQ.metrics.id.YOUTUBE_AVERAGE_DAILY_POSTS_COMMENTS:
            case RivalIQ.metrics.id.INSTAGRAM_AVERAGE_DAILY_POSTS:
            case RivalIQ.metrics.id.INSTAGRAM_AVERAGE_DAILY_POSTS_LIKES:
            case RivalIQ.metrics.id.INSTAGRAM_AVERAGE_DAILY_POSTS_COMMENTS:
            case RivalIQ.metrics.id.INSTAGRAM_INSIGHTS_REACH_PER_DAY:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS_UNIQUE:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS_ORGANIC_UNIQUE:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS_PAID_UNIQUE:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS_VIRAL_UNIQUE:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_CONSUMPTIONS_UNIQUE:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_CONSUMPTIONS_PHOTO_VIEWS_UNIQUE:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_CONSUMPTIONS_OTHER_CLICKS_UNIQUE:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_CONSUMPTIONS_VIDEO_PLAY_UNIQUE:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_CONSUMPTIONS_LINK_CLICKS_UNIQUE:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS_GENDER_AGE_F13_17:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS_GENDER_AGE_F18_24:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS_GENDER_AGE_F25_34:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS_GENDER_AGE_F35_44:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS_GENDER_AGE_F45_54:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS_GENDER_AGE_F44_64:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS_GENDER_AGE_F65_PLUS:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS_GENDER_AGE_M13_17:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS_GENDER_AGE_M18_24:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS_GENDER_AGE_M25_34:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS_GENDER_AGE_M35_44:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS_GENDER_AGE_M45_54:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS_GENDER_AGE_M44_64:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS_GENDER_AGE_M65_PLUS:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS_GENDER_AGE_U13_17:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS_GENDER_AGE_U18_24:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS_GENDER_AGE_U25_34:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS_GENDER_AGE_U35_44:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS_GENDER_AGE_U45_54:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS_GENDER_AGE_U44_64:
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS_GENDER_AGE_U65_PLUS:
            case RivalIQ.metrics.id.LINKED_IN_VISITORS_UNIQUE:
            case RivalIQ.metrics.id.LINKED_IN_OVERVIEW_PAGE_UNIQUE_VIEWS: {
                let maxValue = null;
                _.each(formattedData.values, function (value) {
                    if (value && !_.isNull(value.total) && value.count > 0) {
                        value.total = value.total / value.count;
                        if (_.isNull(maxValue)) {
                            maxValue = value.total;
                        }
                        maxValue = Math.max(value.total, maxValue);
                    }
                    maxValue = Math.max(value.total, maxValue);
                });
                formattedData.maxValue = maxValue;
            }
                break;
            default:
                break;
        }
        return formattedData;
    }

    /**
     * returns the total metric for a source. If the source is hidden, returns null.
     * @param source
     * @param sourceMask channels to redact. passed down to noChannelAccess()
     * @returns {*}
     */
    const getEngagementTotalMetricForSource = function (source, sourceMask) {
        if (noChannelAccess(source, sourceMask)) {
            return null;
        }

        const engagementTotalMetricSourceMap = {};
        engagementTotalMetricSourceMap[RivalIQ.enums.sources.TWITTER] = RivalIQ.metrics.id.TWITTER_TWEETS_ENGAGEMENT_TOTAL;
        engagementTotalMetricSourceMap[RivalIQ.enums.sources.FACEBOOK] = RivalIQ.metrics.id.FACEBOOK_POSTS_ENGAGEMENT_TOTAL;
        engagementTotalMetricSourceMap[RivalIQ.enums.sources.YOUTUBE] = RivalIQ.metrics.id.YOUTUBE_POSTS_ENGAGEMENT_TOTAL;
        engagementTotalMetricSourceMap[RivalIQ.enums.sources.INSTAGRAM] = RivalIQ.metrics.id.INSTAGRAM_POSTS_ENGAGEMENT_TOTAL;
        engagementTotalMetricSourceMap[RivalIQ.enums.sources.TIKTOK] = RivalIQ.metrics.id.TIKTOK_POSTS_ENGAGEMENT_TOTAL;

        return engagementTotalMetricSourceMap[source] || null;
    };

    /**
     * returns the follower count metric for a source. If the source is hidden, will return null.
     * @param source
     * @param sourceMask channels to redact. passed down to noChannelAccess()
     * @returns {*}
     */
    const getFollowerCountMetricForSource = function (source, sourceMask) {

        if (noChannelAccess(source, sourceMask)) {
            return null;
        }

        const followerCountMetricSourceMap = {};

        followerCountMetricSourceMap[RivalIQ.enums.sources.TWITTER] = RivalIQ.metrics.id.TWITTER_PRESENCE_REACH;
        followerCountMetricSourceMap[RivalIQ.enums.sources.FACEBOOK] = RivalIQ.metrics.id.FACEBOOK_PRESENCE_REACH;
        followerCountMetricSourceMap[RivalIQ.enums.sources.YOUTUBE] = RivalIQ.metrics.id.YOUTUBE_PRESENCE_REACH;
        followerCountMetricSourceMap[RivalIQ.enums.sources.INSTAGRAM] = RivalIQ.metrics.id.INSTAGRAM_PRESENCE_REACH;
        followerCountMetricSourceMap[RivalIQ.enums.sources.TIKTOK] = RivalIQ.metrics.id.TIKTOK_PRESENCE_REACH;

        return followerCountMetricSourceMap[source] || null;
    };

    /**
     * Roll up for post engagement rate metrics (e.g. TWITTER_TWEETS_ENGAGEMENT_RATE)
     * sum(engagement_total) / (follower_count)
     * @param compareData
     * @param metricSource
     * @param timeAnalysisMode
     * @param companyId
     * @param dates
     * @param sourceMask channels to redact. passed down to noChannelAccess()
     * @returns {{maxValue: *, values: *}}
     */
    function engagementRateFormattedData(compareData, metricSource, timeAnalysisMode, dates, companyId, sourceMask) {
        const formattedEngagementData = getMetricData(compareData, getEngagementTotalMetricForSource(metricSource, sourceMask), timeAnalysisMode, dates, companyId, sourceMask);
        const formattedFollowerData = getMetricData(compareData, getFollowerCountMetricForSource(metricSource, sourceMask), timeAnalysisMode, dates, companyId, sourceMask);
        const values = [];
        let maxValue = null;
        _.each(formattedEngagementData.values, function (engagement, idx) {
            const value = _.clone(engagement);
            if (engagement && !_.isNull(engagement.total) && !_.isNull(formattedFollowerData.values[idx].total)) {
                value.total = engagement.total / formattedFollowerData.values[idx].total;
                maxValue = Math.max(value.total, maxValue);
            } else {
                value.total = null;
            }
            values.push(value);
        });

        return {
            maxValue: maxValue,
            values: values
        };
    }

    /**
     * returns the post metric for a source. If the source is hidden, will return null.
     *
     * For twitter, return just normal tweets as activity on retweets is not counted for engagement rate.
     *
     * @param source
     * @param sourceMask channels to redact. passed down to noChannelAccess()
     * @returns {*}
     */
    const getPostMetricForSource = function (source, sourceMask) {

        if (noChannelAccess(source, sourceMask)) {
            return null;
        }

        const postMetricSourceMap = {};

        postMetricSourceMap[RivalIQ.enums.sources.TWITTER] = RivalIQ.metrics.id.TWITTER_NORMAL_TWEETS;
        postMetricSourceMap[RivalIQ.enums.sources.FACEBOOK] = RivalIQ.metrics.id.FACEBOOK_POSTS;
        postMetricSourceMap[RivalIQ.enums.sources.YOUTUBE] = RivalIQ.metrics.id.YOUTUBE_POSTS;
        postMetricSourceMap[RivalIQ.enums.sources.INSTAGRAM] = RivalIQ.metrics.id.INSTAGRAM_POSTS;
        postMetricSourceMap[RivalIQ.enums.sources.TIKTOK] = RivalIQ.metrics.id.TIKTOK_POSTS;
        postMetricSourceMap[RivalIQ.enums.sources.CROSS_CHANNEL] = RivalIQ.metrics.id.CROSS_CHANNEL_ACTIVITY;

        return postMetricSourceMap[source] || null;
    };

    /**
     * Roll up for post engagement total metrics (e.g. TWITTER_AVERAGE_TWEET_ENGAGEMENT_TOTAL)
     * sum(engagement_total) / sum(post_count)
     * @param compareData
     * @param metricSource
     * @param timeAnalysisMode
     * @param dates
     * @param companyId
     * @param sourceMask channels to redact. passed down to noChannelAccess()
     * @returns {{maxValue: *, values: Array}}
     */
    function engagementTotalFormattedData(compareData, metricSource, timeAnalysisMode, dates, companyId, sourceMask) {
        const formattedEngagementData = getMetricData(compareData, getEngagementTotalMetricForSource(metricSource, sourceMask), timeAnalysisMode, dates, companyId, sourceMask);
        const formattedPostData = getMetricData(compareData, getPostMetricForSource(metricSource, sourceMask), timeAnalysisMode, dates, companyId, sourceMask);

        const values = [];
        let maxValue = null;
        _.each(formattedEngagementData.values, function (engagement, idx) {
            const value = _.clone(engagement);
            if (engagement && !_.isNull(engagement.total) && !_.isNull(formattedPostData.values[idx].total)) {
                if (formattedPostData.values[idx].total === 0) {
                    value.total = 0;
                } else {
                    value.total = engagement.total / formattedPostData.values[idx].total;
                }
                maxValue = Math.max(value.total, maxValue);
            } else {
                value.total = null;
            }
            values.push(value);
        });

        return {
            maxValue: maxValue,
            values: values
        };
    }

    /**
     * Roll up for average post engagement rate metrics (e.g. TWITTER_AVERAGE_TWEET_ENGAGEMENT_RATE)
     * sum(engagement_total) / (sum(post_count) * follower_count)
     *
     * For metricSources with subSources we cannot accurately average across
     * the aggregates so we compute the weighted average of the submetric
     * averages
     *
     * @param compareData
     * @param metricSource
     * @param timeAnalysisMode
     * @param dates
     * @param companyId
     * @param sourceMask channels to redact. passed down to noChannelAccess()
     * @returns {{maxValue: *, values: *}}
     */
    function averageEngagementRateFormattedData(compareData, metricSource, timeAnalysisMode, dates, companyId, sourceMask) {

        const subSources = RivalIQ.enums.sourceDetails[metricSource].subSources;
        let sources = (subSources ? subSources : [metricSource]);

        sources = _.reject(sources, function (source) {
            return noChannelAccess(source, sourceMask);
        });

        // The denominator of the weight. For single source this will evaluate
        // to 1, for cross_channel it becomes {posts on channel} / {total posts}
        const formattedTotalPostData = getMetricData(compareData, getPostMetricForSource(metricSource, sourceMask), timeAnalysisMode, dates, companyId, sourceMask);

        // Get averages for all sources (self or submetrics)
        let values = _.map(sources, function (source) {
            const formattedEngagementData = getMetricData(compareData, getEngagementTotalMetricForSource(source, sourceMask), timeAnalysisMode, dates, companyId, sourceMask);
            const formattedPostData = getMetricData(compareData, getPostMetricForSource(source, sourceMask), timeAnalysisMode, dates, companyId, sourceMask);
            const formattedFollowerData = getMetricData(compareData, getFollowerCountMetricForSource(source, sourceMask), timeAnalysisMode, dates, companyId, sourceMask);

            return _.map(formattedEngagementData.values, function (engagement, idx) {
                const value = _.clone(engagement);
                const followers = formattedFollowerData.values[idx].total;
                const posts = formattedPostData.values[idx].total;
                const totalPosts = formattedTotalPostData.values[idx].total;

                if (engagement && !_.isNull(engagement.total) && !_.isNull(followers) && !_.isNull(posts)) {

                    let val = 0;
                    const denominator = followers * posts;

                    // Calculate the weighted average
                    if (denominator !== 0) {
                        const weight = (posts / totalPosts);
                        val = weight * engagement.total / denominator;
                    }

                    value.total = val;
                } else {
                    // NOTE: unlike other values, zero when data is missing
                    value.total = 0;
                }

                return value;
            });
        });

        let maxValue = null;

        // Sum the weighted averages across all included channels
        // TODO this sucks b/c we throw away a lot of generated structure and
        // reuse other pieces. Bleh
        values = _.map(_.zip.apply(null, values), function (sourceValues) {
            const result = _.clone(sourceValues[0]);
            const value = _.reduce(sourceValues, function (sum, val) {
                if (val) {
                    sum += val.total;
                }

                return sum;
            }, 0);

            result.total = value;

            // Recalculate max once all channels have been combined
            maxValue = Math.max(result.total, maxValue);

            return result;
        });

        return {
            maxValue: maxValue,
            values: values
        };
    }

    function averageRateFormattedData(compareData, metric, timeAnalysisMode, dates, companyId, sourceMask) {

        let numeratorMetricId;
        let denominatorMetricId;

        switch (metric) {
            case RivalIQ.metrics.id.FACEBOOK_INSIGHTS_PAGE_ENGAGEMENT_RATE: {
                numeratorMetricId = RivalIQ.metrics.id.FACEBOOK_INSIGHTS_CONSUMPTIONS;
                denominatorMetricId = RivalIQ.metrics.id.FACEBOOK_INSIGHTS_IMPRESSIONS;
                break;
            }

            case RivalIQ.metrics.id.LINKED_IN_ENGAGEMENT_RATE: {
                numeratorMetricId = RivalIQ.metrics.id.LINKED_IN_ENGAGEMENT;
                denominatorMetricId = RivalIQ.metrics.id.LINKED_IN_UPDATE_IMPRESSIONS;
                break;
            }

            default:
                throw new Error(`Unsupported metric: ${metric}`);
        }

        const formattedNumeratorData = getMetricData(compareData, numeratorMetricId, timeAnalysisMode, dates, companyId, sourceMask);
        const formattedDeminatorData = getMetricData(compareData, denominatorMetricId, timeAnalysisMode, dates, companyId, sourceMask);

        const values = _.map(formattedNumeratorData.values, function (numerator, idx) {
            const value = _.clone(numerator);
            const denominator = formattedDeminatorData.values[idx].total;

            if (numerator && !_.isNull(numerator.total) && !_.isNull(denominator)) {

                const val = (denominator !== 0 ? numerator.total / denominator : 0);
                value.total = val;
            } else {
                value.total = 0;
            }

            return value;
        });

        const maxValue = _.maxBy(values, 'total').total;

        return {
            maxValue: maxValue,
            values: values
        };
    }

    /**
     * Roll up for average daily post engagement total metrics (e.g. TWITTER_AVERAGE_DAILY_TWEETS_ENGAGEMENT_TOTAL)
     * sum(engagement_total) / days_include_per_period
     * @param compareData
     * @param metricSource
     * @param timeAnalysisMode
     * @param dates
     * @param companyId
     * @param sourceMask channels to redact. passed down to noChannelAccess()
     * @returns {{maxValue: *, values: *}}
     */
    function averageEngagementTotalPerDayFormattedData(compareData, metricSource, timeAnalysisMode, dates, companyId, sourceMask) {
        const formattedEngagementData = getMetricData(compareData, getEngagementTotalMetricForSource(metricSource, sourceMask), timeAnalysisMode, dates, companyId, sourceMask);

        const values = [];
        let maxValue = null;
        _.each(formattedEngagementData.values, function (engagement) {
            const value = _.clone(engagement);
            if (engagement && !_.isNull(engagement.total)) {
                if (engagement.count === 0) {
                    value.total = 0;
                } else {
                    value.total = engagement.total / engagement.count;
                }
                maxValue = Math.max(value.total, maxValue);
            } else {
                value.total = null;
            }
            values.push(value);
        });

        return {
            maxValue: maxValue,
            values: values
        };
    }

    /**
     * Roll up for average daily post engagement rate metrics (e.g. TWITTER_AVERAGE_DAILY_TWEETS_ENGAGEMENT_RATE)
     * sum(engagement_total) / days_include_per_period * follower_count)
     * @param compareData
     * @param metricSource
     * @param timeAnalysisMode
     * @param dates
     * @param companyId
     * @param sourceMask channels to redact. passed down to noChannelAccess()
     * @returns {{maxValue: *, values: *}}
     */
    function averageEngagementRatePerDayFormattedData(compareData, metricSource, timeAnalysisMode, dates, companyId, sourceMask) {
        const formattedEngagementData = getMetricData(compareData, getEngagementTotalMetricForSource(metricSource, sourceMask), timeAnalysisMode, dates, companyId, sourceMask);
        const formattedFollowerData = getMetricData(compareData, getFollowerCountMetricForSource(metricSource, sourceMask), timeAnalysisMode, dates, companyId, sourceMask);

        const values = [];
        let maxValue = null;
        _.each(formattedEngagementData.values, function (engagement, idx) {
            const value = _.clone(engagement);
            if (engagement && !_.isNull(engagement.total) && !_.isNull(formattedFollowerData.values[idx].total)) {
                if (engagement.count === 0 || formattedFollowerData.values[idx].total === 0) {
                    value.total = 0;
                } else {
                    value.total = engagement.total / (engagement.count * formattedFollowerData.values[idx].total);
                }
                maxValue = Math.max(value.total, maxValue);
            } else {
                // NOTE: unlike other values, zero when data is missing
                value.total = 0;
            }
            values.push(value);
        });

        return {
            maxValue: maxValue,
            values: values
        };
    }


    // NOTE export the results, for both server and client
    if (typeof window === 'undefined') {
        module.exports.generateDateSequence = utils.generateDateSequence;
        module.exports.formatChartData = utils.formatChartData;
        module.exports.rollupFormattedChartData = utils.rollupFormattedChartData;
    } else {
        RivalIQ.utils.generateDateSequence = utils.generateDateSequence;
        RivalIQ.utils.formatChartData = utils.formatChartData;
        RivalIQ.utils.rollupFormattedChartData = utils.rollupFormattedChartData;
        RivalIQ.utils.metricComponents = utils.metricComponents;
    }

    /**
     *
     * @param source
     * @param sourceMask
     * @returns true iff the channel is not shown
     */
    function noChannelAccess(source, sourceMask) {
        const mask = RivalIQ.enums.sourceDetails[source].sourceMask;
        return !(sourceMask & mask);
    }
})();
